export default "__VITE_ASSET__BlyV9rJx__"